import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchAllFormulas } from "../../store/slices/formulaSlice";

function EditPayTaxes({ clientData, onDataChange, showTaxReminder = true }) {
  const dispatch = useDispatch();
  const { formulaList } = useSelector((state) => state.formula);

  useEffect(() => {
    dispatch(fetchAllFormulas());
  }, [dispatch]);

  const handleChange = (field, value) => {
    if (onDataChange) onDataChange({ [field]: value });
  };

  // Helper to get current IDs (handling both edited state and initial formulas which might be objects)
  const getCurrentTaxIds = () => {
    if (Array.isArray(clientData?.taxIds) && clientData.taxIds.length > 0) {
      return clientData.taxIds;
    }
    if (Array.isArray(clientData?.formulas) && clientData.formulas.length > 0) {
      return clientData.formulas.map((f) => (typeof f === "object" ? f.id : f));
    }
    return [];
  };

  const handleTaxChange = (id, checked) => {
    let currentTaxIds = [...getCurrentTaxIds()];
    if (checked) {
      if (!currentTaxIds.includes(id)) currentTaxIds.push(id);
    } else {
      currentTaxIds = currentTaxIds.filter((taxId) => taxId !== id);
    }
    onDataChange({ taxIds: currentTaxIds });
  };

  // Split formula list into two columns
  const formulas = formulaList || [];
  const midpoint = Math.ceil(formulas.length / 2);
  const leftColumnFormulas = formulas.slice(0, midpoint);
  const rightColumnFormulas = formulas.slice(midpoint);

  return (
    <div className="editpresoldetail mb_20">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="white_card">
              <div className="row">
                {/* LEFT TITLE */}
                <div className="col-md-2">
                  <h4 className="mt_20">Pay & Tax</h4>
                </div>

                {/* LEFT COLUMN */}
                <div className="col-md-5">
                  <div className="common_input_forms">
                    <div className="form_group">
                      <label>Payroll Cycle</label>
                      <select
                        className="form-control pl_16"
                        value={clientData?.payrollCycle || ""}
                        onChange={(e) =>
                          handleChange("payrollCycle", e.target.value)
                        }
                      >
                        <option value="">Select Cycle</option>
                        <option value="Monthly">Monthly</option>
                        <option value="Weekly">Weekly</option>
                        <option value="BiWeekly">BiWeekly</option>
                        <option value="SemiMonthly">SemiMonthly</option>
                      </select>
                    </div>
                  </div>

                  {showTaxReminder && (
                    <div className="common_input_forms mt_20">
                      <div className="form_group">
                        <label>Tax Reminder</label>
                        <select
                          className="form-control pl_16"
                          value={clientData?.taxScheduleType || ""}
                          onChange={(e) =>
                            handleChange("taxScheduleType", e.target.value)
                          }
                        >
                          <option value="">Select Reminder Type</option>
                          <option value="1">Immediate</option>
                          <option value="2">Monthly</option>
                        </select>
                      </div>
                    </div>
                  )}
                </div>

                {/* RIGHT COLUMN */}
                <div className="col-md-5">
                  {/* TAX SETTINGS LEFT */}
                  <div className="checkboxes mt_24">
                    <h5>Tax Settings</h5>

                    <div className="ms-auto w-100">
                      <form className="text-start">
                        <div className="row">
                          {/* Left Column of Formulas */}
                          <div className="col-md-6">
                            {leftColumnFormulas.map((formula) => (
                              <div
                                className="form-check pb_10 border-bottom"
                                key={formula.id}
                              >
                                <input
                                  id={`tax-${formula.id}`}
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={getCurrentTaxIds().includes(
                                    formula.id,
                                  )}
                                  onChange={(e) =>
                                    handleTaxChange(
                                      formula.id,
                                      e.target.checked,
                                    )
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`tax-${formula.id}`}
                                >
                                  {formula.code}{" "}
                                  <span>({formula.title || formula.name})</span>
                                </label>
                              </div>
                            ))}
                          </div>
                          {/* Right Column of Formulas */}
                          <div className="col-md-6">
                            {rightColumnFormulas.map((formula) => (
                              <div
                                className="form-check pb_10 border-bottom"
                                key={formula.id}
                              >
                                <input
                                  id={`tax-${formula.id}`}
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={getCurrentTaxIds().includes(
                                    formula.id,
                                  )}
                                  onChange={(e) =>
                                    handleTaxChange(
                                      formula.id,
                                      e.target.checked,
                                    )
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`tax-${formula.id}`}
                                >
                                  {formula.code}{" "}
                                  <span>({formula.title || formula.name})</span>
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                {/* END RIGHT */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditPayTaxes;
